var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview-wrapper',{staticClass:"border border-gray-light",attrs:{"image":_vm.image,"title":_vm.place.name,"caption":_vm.getFullAddress(_vm.place)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }